import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { GamePassUserStatsResponse } from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { retryOnTransientErrors } from "./queryUtils";

const buildUserStatsUrl = (userId: string): string =>
  API_ROUTES.GET_GAME_PASS_USER_STATS.replace("{user_id}", userId);

const fetchUserStats = async (
  userId: string,
  seasonId?: string,
): Promise<GamePassUserStatsResponse> => {
  const response = await getPrivateInstance().get<GamePassUserStatsResponse>(
    buildUserStatsUrl(userId),
    {
      params: seasonId
        ? {
            season_id: seasonId,
          }
        : undefined,
    },
  );
  return response.data;
};

type UseGetUserStatsOptions = {
  enabled?: boolean;
};

export const useGetUserStats = (
  userId?: string,
  seasonId?: string,
  options?: UseGetUserStatsOptions,
): UseQueryResult<GamePassUserStatsResponse, Error> =>
  useQuery<GamePassUserStatsResponse, Error>({
    queryKey: ["game-pass", "users", "stats", userId ?? "", seasonId ?? ""],
    queryFn: () => fetchUserStats(userId!, seasonId),
    enabled:
      Boolean(userId && seasonId) && (options?.enabled ?? true),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: retryOnTransientErrors,
  });

export { fetchUserStats };
